import {
    Flex,
    IconArrowRight,
} from '@gmg/gmg-react-components';
import { TFunction } from 'i18next';
import { ROUTES } from 'src/routes';
import BreadCrumbItem, { ViewInfo } from './BreadCrumbItem';

type OrganizationBreadCrumbProps = {
    t: TFunction;
    hasGmgAdminPermission: boolean;
    showParentOrganization?: boolean;
    organizationName: string | undefined;
    parentOrganizationName?: string | undefined;
    parentOrganizationId?: string | undefined;
    viewInfo: ViewInfo;
};

const OrganizationBreadCrumb = ({
    t,
    hasGmgAdminPermission,
    organizationName,
    showParentOrganization,
    parentOrganizationName,
    parentOrganizationId,
    viewInfo,
}: OrganizationBreadCrumbProps) => {
    return (
        <Flex justifyContent="center" alignItems="center" gap="8px">
            {hasGmgAdminPermission && backToOrganizationsListLink(t)}
            {showParentOrganization && parentOrganizationName && parentOrganizationId &&
                backToParentOrganizationLink(parentOrganizationName, parentOrganizationId)}
            <Flex justifyContent="center" alignItems="center" gap="8px">
                <BreadCrumbItem label={organizationName || '...'} />
                <IconArrowRight width={16} height={16} />
            </Flex>
            <BreadCrumbItem label={viewInfo.label} icon={viewInfo.icon} isHighlighted />
        </Flex>
    );
};

const backToOrganizationsListLink = (t: TFunction) =>
    <Flex alignItems="center" gap="8px">
        <BreadCrumbItem
            label={t('Layout.breadcrumb_link_text_GmgAdmin', 'All organizations')}
            to={ROUTES.organizations}
            ariaLabel="System Management"
        />
        <IconArrowRight width={16} height={16} />
    </Flex>;

const backToParentOrganizationLink = (parentName: string, parentId: string) =>
    <Flex alignItems="center" gap="8px">
        <BreadCrumbItem
            label={parentName}
            to={ROUTES.organization.replace(':orgId', parentId)}
            ariaLabel="Head Organization"
        />
        <IconArrowRight width={16} height={16} />
    </Flex>;

export default OrganizationBreadCrumb;
